import { render, staticRenderFns } from "./VoluntariosSecurity.vue?vue&type=template&id=c980f75a"
import script from "./VoluntariosSecurity.vue?vue&type=script&lang=js"
export * from "./VoluntariosSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports